'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var selectedComparisonGridConfig = require('../config/selected-comparison-config.json');
var benchmarkViewGridConfig = require('../config/benchmark-view-config.json');
var RecommendationBenchmarkPanelController = function RecommendationBenchmarkPanelController($window, $scope, $rootScope, dataUtilsService, dataService, dataTransformerService, recommendationEntryDataService, configurationService, $q, momentService, saveAdjustmentsService, faresOptimizerFareTooltipService, faresOptimizerConstants, duplicateWebFaresFinder, fareChartTransformationService, faresOptimizerWebFareChartTransformationService, applicableDatesChartDataService, selectedComparisonDataTransformerService) {
  var applicableDateLabels = [{
    field: 'tripType',
    label: ''
  }, {
    field: 'fareBrandName',
    label: ' '
  }, {
    field: 'season',
    label: 'Season'
  }, {
    field: 'dow',
    label: 'DOW'
  }, {
    field: 'ap',
    label: 'AP'
  }, {
    field: 'mms',
    label: 'MMS'
  }];
  $scope.isRecalculateButtonEnabled = false;
  $scope.isSaveRecalculateButtonEnabled = shouldEnableSaveRecalculateButton($scope.screenState.recommendationDetailsPanel.selectedHostLadder.data.status);
  $scope.$watch('screenState.recommendationDetailsPanel.selectedHostLadder.data.status', function (status) {
    $scope.isSaveRecalculateButtonEnabled = !_.isNil($scope.recalculatedLadder) && shouldEnableSaveRecalculateButton(status);
    $scope.isRecalculateButtonEnabled = false;
  }, true);
  $scope.initializeState = function () {
    var selectedHostLadder = _.cloneDeep($scope.screenState.recommendationDetailsPanel.selectedHostLadder);
    if (selectedHostLadder && !_.isEmpty(selectedHostLadder.data)) {
      $scope.selectedHostLadder = selectedHostLadder;
      $scope.entryLabels = selectedHostLadder.data.entryLabels;
      $scope.entryLevelBenchmark = updateEntryLevelBenchmarkDataWithWebFares(selectedHostLadder.data.entryLevelBenchmark);
      $scope.selectedComparison = selectedHostLadder.data.selectedComparison;
      $scope.hostFbcs = [$scope.setUpChartData(selectedHostLadder.data.entryLevelFbcData)];
      $scope.selectedCompetitors = [$scope.setUpChartData(selectedHostLadder.data.selectedCompetitorData, {
        isCompetitor: true
      })];
    }
    $scope.selectedComparisonGridSettings = {
      displayModel: selectedComparisonGridConfig,
      settings: {
        selection: true,
        multiSelect: true,
        headerCheckBox: false,
        tooltips: {
          fareBrandName: faresOptimizerFareTooltipService.getHostFareBrandDescriptionContent,
          recomTotalFare: faresOptimizerFareTooltipService.getNormalizedTotalFareTooltipContent
        },
        selectiveTooltipRender: {
          fareBrandName: faresOptimizerFareTooltipService.shouldRenderHostFareBrandDescriptionToolTip,
          recomTotalFare: faresOptimizerFareTooltipService.shouldRenderNormalizedTotalFareTooltip
        }
      }
    };
    $scope.benchmarkViewGridSettings = {
      displayModel: benchmarkViewGridConfig,
      settings: {
        selection: true,
        multiSelect: isMultiSelectApplicable(),
        headerCheckBox: false,
        tooltips: {
          fareBrandName: faresOptimizerFareTooltipService.getHostFareBrandDescriptionContent
        },
        selectiveTooltipRender: {
          fareBrandName: faresOptimizerFareTooltipService.shouldRenderHostFareBrandDescriptionToolTip
        }
      }
    };
  };
  function isHideModal() {
    var isHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return isHidden || _.isUndefined($scope.recalculatedLadder) || $scope.recalculatedLadder.category === 'STRUCTURAL' || _.isUndefined($scope.recalculatedLadder.isRecalculatedFareHigher);
  }
  function isExistRecalculateFare() {
    return !_.isUndefined($scope.recalculatedLadder) && faresOptimizerConstants.CATEGORY.TACTICAL === $scope.recalculatedLadder.category;
  }
  $scope.triggerRecalculateRecommendation = function () {
    var fareRecordKey = !_.isNil($scope.selectedComparison[0]._recomId) ? $scope.selectedComparison[0]._recomId : $scope.selectedComparison[0].recomId;
    var selectedCompetitor = $scope.selectedCompetitors[0].data.carrier;
    var compFbc = $scope.selectedCompetitors[0].data.fbc;
    var compOrig = $scope.selectedCompetitors[0].data.origin;
    var compDest = $scope.selectedCompetitors[0].data.destination;
    var compTariffCode = $scope.selectedCompetitors[0].data.tariffCode;
    var compRoutingNumber = $scope.selectedCompetitors[0].data.routingNumber;
    var compFootnote = $scope.selectedCompetitors[0].data.footnote;
    var compFareSource = $scope.selectedCompetitors[0].data.fareSource;
    dataService.getRecalculatedRecommendationLadder(fareRecordKey, selectedCompetitor, compFbc, compOrig, compDest, compTariffCode, compRoutingNumber, compFootnote, null, null, compFareSource).then(function (data) {
      if (!_.isNil(data) && !_.isEmpty(data.failedMap)) {
        var values = _.values(data.failedMap);
        return toastr.error('Recalculate Failed - ' + values);
      }
      data.recalculatedRecommendationLadder._fareRecommendationRecordKey = fareRecordKey;
      data.recalculatedRecommendationLadder.isEntryLevelChanged = fareRecordKey !== data.recalculatedRecommendationLadder.fareRecommendationRecordKey;
      $scope.isRecalculateButtonEnabled = false;
      $scope.isSaveRecalculateButtonEnabled = shouldEnableSaveRecalculateButton(data.recalculatedRecommendationLadder.status);
      updateHostLadderDetails(data.recalculatedRecommendationLadder);
      $scope.hostFbcs = [$scope.setUpChartData($scope.selectedHostLadder.data.entryLevelFbcData)];
      $scope.recalculatedLadder = data.recalculatedRecommendationLadder;
      if (faresOptimizerConstants.CATEGORY.TACTICAL === $scope.recalculatedLadder.category) {
        $window.sessionStorage.setItem(faresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED, JSON.stringify($scope.recalculatedLadder));
      }
      toastr.success('Recalculate Successful');
    })["catch"](function () {
      $scope.isSaveRecalculateButtonEnabled = false;
    });
  };
  $scope.recalculateRecommendation = function () {
    if (_.isNil($scope.selectedComparison)) {
      return;
    }
    if (isExistRecalculateFare()) {
      dataService.deleteRecalculatedRecommendationLadder($scope.recalculatedLadder).then(function (data) {
        if (_.isEmpty(data.failedMap)) {
          $scope.recalculatedLadder = undefined;
          return $scope.triggerRecalculateRecommendation();
        } else {
          $scope.isSaveRecalculateButtonEnabled = true;
          return false;
        }
      })["catch"](function () {
        $scope.isSaveRecalculateButtonEnabled = true;
        return false;
      });
    } else {
      return $scope.triggerRecalculateRecommendation();
    }
  };
  function shouldEnableSaveRecalculateButton(status) {
    return status === 'New' || status === 'Pending' || status === 'No Recom';
  }
  function getOriginalLadder(recalculatedLadder) {
    if (!recalculatedLadder.isEntryLevelChanged) {
      return $q.resolve(null);
    }
    var record_key = $scope.recalculatedLadder._fareRecommendationRecordKey;
    return dataService.getRecommendationData('fareRecommendationRecordKey==' + record_key);
  }
  function expireAndSave(recalculatedLadder, originalLadder) {
    originalLadder = _.first(originalLadder);
    originalLadder.expiryTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP).toISOString();
    originalLadder.cabinCode = originalLadder.cabin;
    if (originalLadder.recommendationEffectiveDate) {
      originalLadder.recommendationEffectiveDate = momentService.of(originalLadder.recommendationEffectiveDate, momentService.FIELD.EVENT_TIME_STAMP).toISOString();
    }
    return recommendationEntryDataService.bulkExpireLadders([originalLadder]).then(function () {
      return recommendationEntryDataService.upsertLadderAndUpdateHostDetailsInCompLadder({
        oldLadderRecordKey: originalLadder.fareRecommendationRecordKey,
        recalculatedLadder: recalculatedLadder
      });
    });
  }
  function isShowSaveConfirmModal(isHidden) {
    if (isHideModal(isHidden)) {
      return false;
    }
    $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:showConfirmModal', {
      modalContent: 'isShowSaveModalContent',
      ignoreApply: true
    });
    return true;
  }
  $scope.saveRecalculatedRecommendation = function () {
    var isHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isShowSaveConfirmModal(isHidden)) {
      return false;
    }
    getOriginalLadder($scope.recalculatedLadder).then(function (originalLadder) {
      return originalLadder ? expireAndSave($scope.recalculatedLadder, originalLadder) : recommendationEntryDataService.upsertLadder($scope.recalculatedLadder);
    }).then(function () {
      if (faresOptimizerConstants.CATEGORY.TACTICAL === $scope.recalculatedLadder.category) {
        $window.sessionStorage.removeItem(faresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED);
      }
      $scope.isSaveRecalculateButtonEnabled = false;
      $scope.isRecalculateButtonEnabled = false;
      var result = dataTransformerService.transformRecommendationLadder({
        foRecommendationLadderList: [$scope.recalculatedLadder]
      });
      $scope.screenState.recommendationDetailsPanel.selectedHostLadder = _.cloneDeep($scope.selectedHostLadder);
      dataTransformerService.updateRecommendation($scope.screenState.displayedRawData, result[0]);
      dataTransformerService.updateRecommendation($scope.screenState.rawData, result[0]);
      var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.contextData.fareLaddersInGroup;
      var originalFareLadder = _.find(fareLaddersInGroup, {
        fareRecommendationRecordKey: $scope.recalculatedLadder._fareRecommendationRecordKey
      });
      var index = _.indexOf(fareLaddersInGroup, originalFareLadder);
      fareLaddersInGroup.splice(index, 1, result[0]);
      $scope.recalculatedLadder._fareRecommendationRecordKey = $scope.recalculatedLadder.fareRecommendationRecordKey;
      updateHostLadderDetails($scope.recalculatedLadder);
      $scope.recalculatedLadder = undefined;
      $scope.screenState.reorderGroupOptions = false;
    })["catch"](function () {
      $scope.isSaveRecalculateButtonEnabled = true;
    });
  };
  function updateHostLadderDetails(data) {
    $scope.selectedComparison = selectedComparisonDataTransformerService.buildSelectedComparisonData(data);
    var result = dataTransformerService.transformRecommendationLadder({
      foRecommendationLadderList: [data]
    });
    $scope.selectedHostLadder.data = result[0];
    $scope.selectedHostLadder.data.status = data.status;
    $scope.selectedHostLadder.data.displayStatus = data.status;
    $scope.selectedHostLadder.labels = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.labels;
    $scope.selectedHostLadder.title = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.title;
    $scope.entryLevelBenchmark = updateEntryLevelBenchmarkDataIfEntryLevelChanged(data);
  }
  function updateEntryLevelBenchmarkDataWithWebFares(atpcoCompetitorFares) {
    atpcoCompetitorFares = atpcoCompetitorFares || [];
    var webFaresByCarrierAndFareType = $scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType;
    var flattenedWebFares = _.cloneDeep(_.flatten(_.map(webFaresByCarrierAndFareType, 'webFares')));
    var webFaresStatistics = duplicateWebFaresFinder.countDuplicateObjects(flattenedWebFares);
    var uniqueWebFares = populateCountToFareSource(webFaresStatistics);
    return atpcoCompetitorFares.concat(uniqueWebFares);
  }
  function getEntryTitle(entry, chartType) {
    var title = 'HOST: ' + entry.fbc;
    if (chartType) {
      if (chartType.isCompetitor) {
        title = entry.fareSource + ': ' + entry.carrier + ': ' + entry.fbc + '(' + entry.compMarket + ')';
      } else if (chartType.isWebFare) {
        title = entry.carrier + ': ' + faresOptimizerConstants.WEB_FARE_CHART_TITLE + ': ' + entry.tripType;
      }
    }
    return title;
  }
  $scope.setUpChartData = function (entry, chartType) {
    if (!_.isEmpty(entry)) {
      return {
        title: getEntryTitle(entry, chartType),
        data: chartType && chartType.isWebFare ? entry.data : entry,
        labels: chartType && chartType.isWebFare ? '' : mapLabels(entry, applicableDateLabels)
      };
    } else {
      return {
        title: 'No selected competitor',
        data: {},
        labels: []
      };
    }
  };
  $scope.backToOriginalScreen = function () {
    $scope.screenState.recommendationDetailsPanel.visible = false;
  };
  function mapLabels(sourceItem, labelFields) {
    return _.map(labelFields, function (groupingItem) {
      var value = !_.isNil(sourceItem[groupingItem.field]) ? sourceItem[groupingItem.field] : '';
      return groupingItem.field === 'season' ? value + ' ' + groupingItem.label : groupingItem.label + ' ' + value;
    });
  }
  $scope.getSelectedBenchmarkRow = function () {
    var selectedBenchmark = _.find($scope.entryLevelBenchmark, {
      selected: true
    });
    if (!_.isNil(selectedBenchmark)) {
      var isSelectedWebFare = selectedBenchmark.fareSource.includes(faresOptimizerConstants.FARE_SOURCE.WEB_FARE);
      if (isSelectedWebFare) {
        $scope.webFareChartData = {};
        $scope.settings = _.isNil($scope.settings) ? {
          type: 'webfare'
        } : $scope.settings;
        var allWebFares = getWebFares();
        var duplicateWebFares = duplicateWebFaresFinder.getDuplicateWebFares(allWebFares, selectedBenchmark);
        _.assign(duplicateWebFares, allWebFares);
        duplicateWebFares = getWebFareChartData(duplicateWebFares);
        $scope.webFareChartData.data = _.cloneDeep(fareChartTransformationService.transformWebFareData(duplicateWebFares.data, $scope.settings));
        $scope.webFareChartData.title = getEntryTitle(duplicateWebFares, {
          isWebFare: true
        });
      } else {
        $scope.webFareChartData = undefined;
      }
      $scope.selectedCompetitors = [getSelectedEntryLevelBenchmarkChartData(selectedBenchmark)];
      $scope.isRecalculateButtonEnabled = ($scope.selectedHostLadder.data.status === 'New' || $scope.selectedHostLadder.data.status === 'Pending' || $scope.selectedHostLadder.data.status === 'No Recom') && isApplicableInventoryAssignmentMethod();
    } else {
      _.forEach($scope.entryLevelBenchmark, function (data) {
        if (data.previousState !== data.selected) {
          data.selected = true;
        }
      });
    }
    updatePreviousStateOfSelection();
  };
  $scope.getSelectedRowInSelectedBenchMarkAirline = function () {
    var hostHighestFbc = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data.hostHighestFbc;
    var category = $scope.screenState.recommendMode;
    var hostCarrier = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data.carrier;
    var selectedComparison = $scope.selectedComparison;
    var selectedBenchmark = applicableDatesChartDataService.getAllSelectedData(selectedComparison, category, hostHighestFbc);
    var compChartData = applicableDatesChartDataService.getCompChartData(selectedBenchmark, hostCarrier);
    var hostChartData = applicableDatesChartDataService.getHostChartData(selectedBenchmark, hostCarrier);
    setUpChartData(compChartData, {
      isCompetitor: true
    });
    setUpChartData(hostChartData, true);
  };
  function getWebFares() {
    var webFaresByCarrierAndFareType = _.cloneDeep($scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType);
    var today = momentService.systemNow(momentService.TYPE.LOCAL_DATE);
    return _.cloneDeep(_.flatten(_.map(webFaresByCarrierAndFareType, function (eachWebFareByCarrier) {
      var webFareDetails = faresOptimizerWebFareChartTransformationService.getWebFaresFromDateAndCheckForTodayRecord(eachWebFareByCarrier.webFares, today, false);
      if (webFareDetails.filteredWebFares.length > 0) {
        // only if we have at least one record to plot the graph
        webFareDetails.filteredWebFares = _.cloneDeep(faresOptimizerWebFareChartTransformationService.fillDummyDates(webFareDetails.filteredWebFares, webFareDetails.isExistTodayRecord, today));
      }
      return webFareDetails.filteredWebFares;
    })));
  }
  function getWebFareChartData(webFareDetails) {
    return {
      carrier: webFareDetails[0].carrier,
      tripType: webFareDetails[0].tripType,
      data: webFareDetails
    };
  }
  function getSelectedEntryLevelBenchmarkChartData(selectedBenchmark) {
    var selectedEntryLevelBenchmark = selectedBenchmark.fareSource === faresOptimizerConstants.FARE_SOURCE.ATPCO ? getSelectedEntryLevelBenchmark(selectedBenchmark) : getSelectedEntryLevelBenchmarkWebFare(selectedBenchmark);
    return $scope.setUpChartData(selectedEntryLevelBenchmark, {
      isCompetitor: true
    });
  }
  function getSelectedEntryLevelBenchmarkWebFare(fareRecord) {
    return {
      market: fareRecord.market,
      carrier: fareRecord.carrier,
      compMarket: fareRecord.compMarket,
      origin: fareRecord.origin,
      destination: fareRecord.destination,
      fareSource: fareRecord.fareSource,
      fbc: fareRecord.fbc,
      tariffCode: fareRecord.tariffCode,
      season: dataUtilsService.getSeasonDefinition(fareRecord.seasonIndicator, fareRecord.fbc),
      effectiveDate: fareRecord.effectiveDate,
      outboundSeasons: fareRecord.outboundSeasons,
      outboundTravelDates: fareRecord.outboundTravelDates,
      ticketingDates: fareRecord.ticketingDates,
      tripType: fareRecord.tripType,
      footnote: fareRecord.footnote
      // fareBrand: fareRecord.fareBrand,
      // fareBrandName: fareRecord.fareBrandName
    };
  }
  function getSelectedEntryLevelBenchmark(fareRecord) {
    var outboundDaysOfWeek = dataUtilsService.convertDayOfWeekNumber(fareRecord.daysOfWeek);
    return {
      market: fareRecord.market,
      carrier: fareRecord.carrier,
      compMarket: fareRecord.compMarket,
      origin: fareRecord.origin,
      destination: fareRecord.destination,
      fareSource: fareRecord.fareSource,
      fbc: fareRecord.fbc,
      tariffCode: fareRecord.tariffCode,
      routingNumber: fareRecord.routingNumber,
      footnote: fareRecord.footnote,
      season: dataUtilsService.getSeasonDefinition(fareRecord.seasonIndicator, fareRecord.fbc),
      dow: outboundDaysOfWeek,
      ap: fareRecord.ap,
      mms: fareRecord.minStay + ' - ' + fareRecord.maxStay,
      travelFromDate: fareRecord.travelFromDate,
      travelToDate: fareRecord.travelToDate,
      travelCompleteDate: fareRecord.travelCompleteDate,
      firstTicketDate: fareRecord.firstTicketDate,
      lastTicketDate: fareRecord.lastTicketDate,
      effectiveDate: fareRecord.effectiveDate,
      discontinueDate: fareRecord.discontinueDate,
      outboundSeasons: fareRecord.outboundSeasons,
      outboundBlackouts: fareRecord.outboundBlackouts,
      inboundSeasons: fareRecord.inboundSeasons,
      inboundBlackouts: fareRecord.inboundBlackouts,
      inboundTravelDates: fareRecord.inboundTravelDates,
      outboundTravelDates: fareRecord.outboundTravelDates,
      ticketingDates: fareRecord.ticketingDates,
      tripType: fareRecord.tripType,
      fareBrand: fareRecord.fareBrand,
      fareBrandName: fareRecord.fareBrandName
    };
  }
  function populateCountToFareSource(webFaresStatistics) {
    return _.map(webFaresStatistics, function (entry) {
      if (entry.count > 1) {
        entry.value.fareSource = entry.value.fareSource + '(' + entry.count + ')';
      }
      return entry.value;
    });
  }
  function setUpChartData(compData, chartType) {
    var applicableDateChart = [];
    _.forEach(compData, function (data) {
      applicableDateChart.push($scope.setUpChartData(getSelectedEntryLevelBenchmark(data), chartType));
    });
    if (applicableDateChart.length === 0) {
      applicableDateChart.push($scope.setUpChartData());
    }
    if (chartType.isCompetitor) {
      $scope.selectedCompetitors = applicableDateChart;
    } else {
      $scope.hostFbcs = applicableDateChart;
    }
  }
  function isApplicableInventoryAssignmentMethod() {
    return $scope.selectedHostLadder.data.rbdMethod === faresOptimizerConstants.RBD_METHOD.ENTRY_LEVEL_RBD;
  }
  function isMultiSelectApplicable() {
    return $scope.selectedHostLadder.data.rbdMethod === undefined ? false : $scope.selectedHostLadder.data.rbdMethod !== 'ENTRY LEVEL RBD';
  }
  function updatePreviousStateOfSelection() {
    _.forEach($scope.entryLevelBenchmark, function (data) {
      data.previousState = data.selected;
    });
  }
  function updateEntryLevelBenchmarkDataIfEntryLevelChanged(data) {
    var entryLevelData = [];
    populateKeyForCompetitor(data);
    _.forEach($scope.entryLevelBenchmark, function (compFare) {
      if (data.isEntryLevelChanged) {
        var comp = _.find(data.competitorFares, {
          'competitorKey': compFare.competitorKey
        });
        compFare.hostRbd = comp && comp.hostRbd;
      }
      entryLevelData.push(compFare);
    });
    return entryLevelData;
  }
  function populateKeyForCompetitor(recommendationLadder) {
    _.forEach(recommendationLadder.competitorFares, function (entry) {
      entry.competitorKey = [entry.carrier, entry.origin, entry.destination, entry.fareBasisCode, entry.routingNumber, entry.tariffCode, entry.footnote].filter(Boolean).join('-');
    });
  }
  $scope.isUserAuthorizedForCurrentPos = function () {
    var pos = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data.pos;
    return saveAdjustmentsService.isUserAuthorizedForCurrentPos(pos);
  };

  // handle toggle between total and base Web Fare
  $scope.$on('chart.webfare.toggle.faretype', function (evt, webFareByCarrier) {
    $scope.$broadcast('chart.webfare.toggle.faretype.data', webFareByCarrier);
  });
  $rootScope.$on('foAnalysisToolbar:recalculatedFarePresent:saveRecalculatedRecommendation', function (evt, param) {
    $scope.saveRecalculatedRecommendation(true);
  });
  $rootScope.$on('foAnalysisToolbar:recalculatedFarePresent:recalculateRecommendation', function (evt, param) {
    $scope.recalculateRecommendation(true);
  });
  $rootScope.$on('foAnalysisToolbar:recalculatedFarePresent:clearRecalculatedRecommendation', function (evt, isSuccess) {
    if (isSuccess === true) {
      $scope.recalculatedLadder = undefined;
    } else {
      $scope.isSaveRecalculateButtonEnabled = true;
    }
  });
  $scope.initializeState();
};
RecommendationBenchmarkPanelController.$inject = ['$window', '$scope', '$rootScope', 'FaresOptimizerAnalysisDataUtilsService', 'FaresOptimizerAnalysisDataService', 'FaresOptimizerDataTransformerService', 'RecommendationEntryDataService', 'ConfigurationService', '$q', 'MomentService', 'FaresOptimizerSaveAdjustmentsService', 'FaresOptimizerFareTooltipService', 'FaresOptimizerConstants', 'DuplicateWebFaresFinder', 'FareChartTransformationService', 'FaresOptimizerWebFareChartTransformationService', 'ApplicableDatesChartDataService', 'SelectedComparisonDataTransformerService'];
module.exports = RecommendationBenchmarkPanelController;